import { useState } from "react";

function useProvideAuth() {

  // *For User
  const [user, setUser] = useState(JSON.parse(localStorage?.getItem('user')));
  const [userDetail, setUserDetail] = useState();

  // *For Login
  const userLogin = (data) => {
    localStorage.setItem('user', JSON.stringify(data))
    setUser(data)
  };

  // *For User Detail
  const saveUserDetail = (data) => {
    setUserDetail(data)
  };

  // *For Logout
  const userLogout = async () => {
    const sessionId = localStorage?.getItem('sessionId')
    setUser(null)
    localStorage.clear()
    localStorage?.setItem('sessionId', sessionId)
  };

  return {
    user,
    userDetail,
    userLogin,
    userLogout,
    saveUserDetail
  };
}

export default useProvideAuth;